import Styled from 'styled-components';

import { media } from '../../lib/StyledComponents';
import { MaxWidthContainer } from '../Layout';

export const enum HeaderPadding {
  Small = '0 1em',
  Medium = '0 1.5em',
  XLarge = '0'
}

export const HeaderInnerContainer = Styled(MaxWidthContainer.withComponent('nav'))`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: center;
  height: 100%;
  padding: ${HeaderPadding.Small};

  ${media.medium`
    padding: ${HeaderPadding.Medium};
  `}

  ${media.xlarge`
    padding: ${HeaderPadding.XLarge};
  `}
`;
